// Copyright (C) 2021 Bystronic Laser AG

import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { Aggregate } from '@/models/metrics/aggregates';
import { formatDateForDateGrouping } from './dates';

export function isCategoryXAxis(
  timeAxisSpan: FilterTimeAxisSpanEnum | undefined,
  dataLength: number,
): boolean {
  if (dataLength === 1) {
    /* If there is only one data point it has to be treated as category axis to avoid showing
    incorrect values in xAxis */
    return true;
  }
  return isCategoryAxisDateGrouping(timeAxisSpan);
}

export function isCategoryAxisDateGrouping(
  timeAxisSpan: FilterTimeAxisSpanEnum | undefined,
) {
  switch (timeAxisSpan) {
    // Category axis instead of time axis for weeks and quarters
    case FilterTimeAxisSpanEnum.Week:
    case FilterTimeAxisSpanEnum.Quarter:
      return true;
    default:
      return false;
  }
}

/** @deprecated Use getTooltipTitle instead. */
export function getDateTooltipLabel(
  datetime: string,
  timeAxisSpan: FilterTimeAxisSpanEnum | undefined,
): string {
  return datetime.substring(0, lengthOfLabel(timeAxisSpan));
}

function lengthOfLabel(
  timeAxisSpan: FilterTimeAxisSpanEnum | undefined,
): number {
  switch (timeAxisSpan) {
    case FilterTimeAxisSpanEnum.Hour:
      return 16; // 2023-01-19 12:34
    case FilterTimeAxisSpanEnum.Month:
      return 7; // 2023-01
    case FilterTimeAxisSpanEnum.Year:
      return 4; // 2023
    default:
      return 10; // 2023-01-19
  }
}

export function getTooltipTitle(
  axisValue: string | number,
  dateGrouping: FilterTimeAxisSpanEnum,
  isCategoryAxis: boolean,
): string {
  if (isCategoryAxis) {
    return axisValue.toString();
  }
  return formatDateForDateGrouping(axisValue, dateGrouping);
}

export function getMaxMinAggregatesMarkData(
  aggregates: Aggregate[] | undefined,
): any[] {
  return (aggregates ?? [])
    ?.filter(
      (aggregate) => aggregate === Aggregate.Max || aggregate === Aggregate.Min,
    )
    .map((aggregate) => ({ type: aggregate }));
}

export function getAverageAggregateMarkData(
  aggregates: Aggregate[] | undefined,
): any[] {
  return (aggregates ?? [])
    ?.filter((aggregate) => aggregate === Aggregate.Average)
    .map((aggregate) => ({
      type: aggregate,
      itemStyle: { color: '#cf5a5a' },
    }));
}
